<micro-select-combo #sel
              placeholder="ITSM Object Type"
              [mode]="mode"
              [(id)]="itsmObjectTypeId"
              (idChange)="change($event)"
              [options]="options"
              [required]="required"
              [disabled]="disabled"
>
</micro-select-combo>
